module.exports = __webpack_public_path__ + "img/logo.7ad35b7f.png";